import { Component, OnInit, Input, ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { SocialMediaConfig } from '../../models/socialMediaConfig'
import { Globals } from '../../models/Globals';

declare var FB: { ui, init };
declare var socialMediaConfig: SocialMediaConfig;
@Component({
	selector: 'app-social-media-sharing',
	templateUrl: './social-media-sharing.component.html',
	styleUrls: ['./social-media-sharing.component.css']
})

export class SocialMediaSharingComponent implements OnInit, AfterViewInit {

	private itemUrl; 
	get ItemUrl(): any { 
	  return this.itemUrl;
	}
	@Input()
	set ItemUrl(val: any) {
	  this.itemUrl =  val;
	}

	private text; 
	get Text(): any { 
	  return this.text;
	}
	@Input()
	set Text(val: any) {
	  this.text = val;
	}

	public shareButtons;
	public sharingConfig: SocialMediaConfig;
	isArabic: boolean;
	@ViewChild('share') shareWrapper: ElementRef;

	constructor(private elementRef: ElementRef) { }

	ngOnInit() {

		this.isArabic = Globals.Culture == "ar";
		this.loadFacebookSDK();
	}

	ngAfterViewInit() {
		//Check if the config is declared or not
		this.sharingConfig = typeof socialMediaConfig === "undefined" ? null : socialMediaConfig;
	}

	loadFacebookSDK(_id?: number) {
		//Todo: Check Culture
		let locale = this.isArabic ? "ar_EG" : "en_GB";
		let url = "https://connect.facebook.net/" + locale + "/sdk.js";

		let isLoadedBefore = document.querySelector('script[src="' + url + '"]') != null;

		if (isLoadedBefore) {
			console.log("LoadedBefore");
			return;
		}

		let scriptNode = document.createElement('script');
		let src = url;
		scriptNode.src = src;
		scriptNode.id = "facebook-jssdk";
		document.getElementsByTagName('body')[0].appendChild(scriptNode);
		window['fbAsyncInit'] = this.fbAsyncInit.bind(this);
	}

	//Facebook SDK initialization 
	fbAsyncInit() {
		//debugger;
		if (typeof FB === "undefined")
			return;
		var x = this.sharingConfig.appId;
		FB.init({
			appId: (this.sharingConfig && this.sharingConfig.appId),
			xfbml: true,
			version: (this.sharingConfig && this.sharingConfig.fbSDKVersion),
		});
	};

	tweetClick = ($event: Event) => {
		$event.preventDefault();
		$event.stopPropagation();

		if (!this.itemUrl)
			return false;

		let account = "";
		let prefix = "";
		let tweetMaxLength = 280;

		if (this.sharingConfig) {
			if (this.sharingConfig.tweetMaxLength)
				tweetMaxLength = this.sharingConfig.tweetMaxLength;

			if (this.sharingConfig.subjectPrefix)
				prefix = this.sharingConfig.subjectPrefix;

			if (this.sharingConfig.twitterAccount)
				account = (this.sharingConfig.twitterAccount.charAt(0) === "@" ? this.sharingConfig.twitterAccount : "@" + this.sharingConfig.twitterAccount);
		}
		let truncateNumber = tweetMaxLength - (prefix.length + account.length);
		let tweet = `${account} ${this.text.substr(0, truncateNumber)} ${prefix}`;

		window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(tweet)}&url=${encodeURIComponent(this.itemUrl)}`, '_blank', 'width=670,height=500');

		return false;
	}


	fbShareClick = ($event: Event) => {
		//debugger;
		$event.preventDefault();
		$event.stopPropagation();

		if (typeof FB === "undefined")
			return false;

		if (!this.itemUrl)
			return false;

		FB.ui({
			method: 'share',
			href: this.itemUrl,
			mobile_iframe: true,
			display: 'popup'
		}, (response) => { });

		return false;
	}

	shareToggle = ($event: Event) => {
		//debugger;
		$event.preventDefault();
		$event.stopPropagation();

		this.shareWrapper.nativeElement.classList.toggle('open');

		return false;
	}
}
